function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Field, Formik } from 'formik';
import React, { useState } from 'react';
import { Button, Form, FormGroup, FormFeedback, Spinner, Row, Col } from 'reactstrap';
import * as yup from 'yup';
import { _translate as t, _Translator as translator } from "../../../../../services/core";
import Input from "../../../../common/input";
import useLogin from "./use-login";
import MagicLogin from "./magic";
export default (function (_ref) {
  var onFailed = _ref.onFailed,
    event = _ref.event;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMagicLink = _useState2[0],
    setIsMagicLink = _useState2[1];
  var _useLogin = useLogin({
      event: event,
      onFailed: onFailed
    }),
    onSubmit = _useLogin.onSubmit,
    loading = _useLogin.loading;
  if (isMagicLink) {
    return /*#__PURE__*/React.createElement(MagicLogin, {
      onSubmit: onSubmit.Magic,
      loading: loading,
      goBack: setIsMagicLink
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Formik, {
    onSubmit: onSubmit.Login,
    initialValues: {
      username: '',
      plainPassword: ''
    },
    validationSchema: yup.object({
      username: yup.string().required(translator.translate('field_required')),
      plainPassword: yup.string()
    })
  }, function (_ref2) {
    var handleSubmit = _ref2.handleSubmit,
      handleBlur = _ref2.handleBlur,
      errors = _ref2.errors,
      touched = _ref2.touched;
    return /*#__PURE__*/React.createElement(Form, {
      noValidate: true,
      role: "form",
      onSubmit: handleSubmit
    }, /*#__PURE__*/React.createElement(FormGroup, {
      className: "mb-3",
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/React.createElement("h5", {
      className: "component-subtitle text-left ml-2"
    }, t('collectorapp_email'), "*"), /*#__PURE__*/React.createElement(Input, {
      className: "material-input",
      tag: Field,
      name: "username",
      placeholder: "",
      autoComplete: "false",
      icon: "user",
      onBlur: handleBlur,
      required: true,
      error: errors.username && touched.username,
      invalid: errors.username && touched.username
    }), errors.username, touched.username && /*#__PURE__*/React.createElement(FormFeedback, null, errors.username)), /*#__PURE__*/React.createElement(FormGroup, {
      className: "mb-1",
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/React.createElement("h5", {
      className: "component-subtitle text-left ml-2"
    }, t('collectorapp_password'), "*"), /*#__PURE__*/React.createElement(Input, {
      className: "material-input",
      tag: Field,
      placeholder: '',
      type: "password",
      name: "plainPassword",
      autoComplete: "false",
      icon: "lock",
      onBlur: handleBlur,
      invalid: errors.password && touched.password,
      required: true
    }), touched.plainPassword && /*#__PURE__*/React.createElement(FormFeedback, null, errors.plainPassword)), /*#__PURE__*/React.createElement(Row, {
      className: "mb-2"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: "12",
      className: "text-left"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("small", null, t('collectorapp_forgot_password'), '  ', /*#__PURE__*/React.createElement("a", {
      className: "forgotpassword text-pink-wever text-underline",
      onClick: setIsMagicLink
    }, t('collectorap_connect_with_magic_link')))))), /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, loading ? /*#__PURE__*/React.createElement(Spinner, {
      size: "md"
    }) : /*#__PURE__*/React.createElement(Button, {
      outline: true,
      color: "default",
      type: "submit",
      className: "btn-wever ",
      disabled: loading
    }, t('collectorapp_connect'))));
  }));
});